// extracted by mini-css-extract-plugin
export default {"link":"LinkIcon_link__BNZLa","badge":"LinkIcon_badge__rTKWN"};